export default __webpack_public_path__ + "static/media/check-icon.907cf8ec.svg";